<template>
  <div class="player-controls__item">
    <AppBtn
      round
      icon-only
      border="bottom"
      class="player-controls__btn"
      :disabled="disabled"
      :loading="loading"
      :color="color"
      @click="click"
    >
      <SvgIcon :key="icon" class="ma-0" size="40" :name="icon" />
    </AppBtn>
    <div class="player-controls__text" v-html="text" />
  </div>
</template>

<script>
export default {
  name: "PlayerControlItem",
  props: {
    disabled: Boolean,
    loading: Boolean,
    icon: String,
    text: String,
    color: String
  },

  methods: {
    click(e) {
      if (!this.disabled && !this.loading) this.$emit("click", e);
    }
  }
};
</script>
